import * as React from "react";
import { SVGProps } from "react";
export const BoldIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7.03125 16C6.61875 16 6.26562 15.8531 5.97187 15.5594C5.67812 15.2656 5.53125 14.9125 5.53125 14.5V5.5C5.53125 5.0875 5.67812 4.73438 5.97187 4.44063C6.26562 4.14688 6.61875 4 7.03125 4H10.2812C11.2099 4 12.067 4.28694 12.8527 4.86083C13.6384 5.43486 14.0312 6.23125 14.0312 7.25C14.0312 7.95833 13.875 8.51042 13.5625 8.90625C13.25 9.30208 12.9549 9.59056 12.6771 9.77167C13.0382 9.93778 13.4271 10.2361 13.8438 10.6667C14.2604 11.0972 14.4688 11.7292 14.4688 12.5625C14.4688 13.8264 14.0028 14.7153 13.071 15.2292C12.1394 15.7431 11.265 16 10.4479 16H7.03125ZM8.17708 13.5417H10.3579C11.029 13.5417 11.434 13.3715 11.5729 13.0312C11.7118 12.691 11.7812 12.4444 11.7812 12.2917C11.7812 12.1389 11.7083 11.8924 11.5625 11.5521C11.4167 11.2118 10.9896 11.0417 10.2812 11.0417H8.17708V13.5417ZM8.17708 8.70833H10.1146C10.5729 8.70833 10.9097 8.58681 11.125 8.34375C11.3403 8.10069 11.4479 7.84028 11.4479 7.5625C11.4479 7.22917 11.3291 6.95833 11.0915 6.75C10.8538 6.54167 10.5463 6.4375 10.169 6.4375H8.17708V8.70833Z"
            fill="currentColor"
        />
    </svg>
);
BoldIcon.displayName = "BoldIcon";
